import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { LockClosedIcon } from '@heroicons/react/24/solid';

import { GateBannerCard } from './GateBannerCard';

interface ClosedCommunityBannerProps {
  onSignIn?: () => void;
}

export const ClosedCommunityBanner: FC<ClosedCommunityBannerProps> = ({ onSignIn }) => {
  const { t } = useTranslation();

  return (
    <GateBannerCard>
      <div className="flex size-12 items-center justify-center rounded-full bg-community-text-on-bg/10">
        <LockClosedIcon aria-hidden="true" className="size-5 text-community-text-on-bg/80" />
      </div>
      <h2 className="mt-4 text-xl font-semibold leading-7 tracking-[-0.4px]">
        {t('community.paid_gate.closed_title')}
      </h2>
      <p className="mt-2 max-w-md text-sm leading-5 text-community-text-on-bg/60">
        {t('community.paid_gate.closed_description')}
      </p>
      {onSignIn && (
        <p className="mt-8 text-[13px] leading-6 text-community-text-on-bg/50">
          {t('community.join.already_member')}{' '}
          <button
            type="button"
            onClick={onSignIn}
            className="underline transition-colors duration-150 hover:text-community-text-on-bg"
          >
            {t('shared.cta.sign_in')}
          </button>
        </p>
      )}
    </GateBannerCard>
  );
};
